<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<app-loading-screen [hidden]="!loading"></app-loading-screen>
<div class="app-content">
  <router-outlet></router-outlet>
</div>
